/* eslint-disable camelcase */
import React, { useCallback, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';

import { logging } from '../../actions/log';
import Toast from '../Toast/Toast';
// import CheckSoft from '../Forum/CheckSoft/CheckSoft';
import styles from './Comment.module.less';
import { postForumAddComment, setLenovoSoft } from '../../actions/forum';
import { byteLength } from '../../utils/utils';
import xss from 'xss';
import CommentReview from './CommentReview';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);
const selectForumAddComment = createSelector(
  state => state.forum,
  forum => forum.forumAddComment,
);
const selectUserInfo = createSelector(
  state => state.user,
  user => user.userInfo,
);

export default props => {
  const { commentId, relaseId, maxLength = 300, type, logInfo = {} } = props;
  const dispatch = useDispatch();
  const logInfoData = useSelector(selectLogInfo);
  const userInfo = useSelector(selectUserInfo);
  const forumAddComment = useSelector(selectForumAddComment);

  // const [checkSoftList, setCheckSoftList] = useState([]);
  const [value, setValue] = useState('');
  const [isNoValue, setIsNoValue] = useState(null);
  const [submitTime, setSubmitTime] = useState(+new Date());
  const [isSubmitLogin, setIsSubmitLogin] = useState(false);
  // const [updateCheckSoft, setUpdateCheckSoft] = useState(false);

  useEffect(() => {
    return () => {
      dispatch(setLenovoSoft({ word: '', pageKey: 'comment', data: {} }));
    };
  }, [dispatch]);

  useEffect(() => {
    if (forumAddComment.submitTime === submitTime && !forumAddComment.loading) {
      dispatch(
        logging({
          category: 'R',
          action: 'Detail_Comment_Result',
          label: '',
          param2: {
            source: logInfo.source,
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            status: forumAddComment.status,
            id: forumAddComment.bizId,
          },
        }),
      );
      if (forumAddComment.status === 0) {
        setValue('');
        // setCheckSoftList([]);
        setIsNoValue(null);
        // setUpdateCheckSoft(true);
        // setTimeout(() => {
        //   setUpdateCheckSoft(false);
        // }, 20);
      }
    }
  }, [forumAddComment, submitTime]);

  useEffect(() => {
    if (isSubmitLogin === true) {
      const login_status = window.CallNativeMethod('get_login_status');
      if (login_status === '1' && userInfo.st) {
        handleAddComment();
        setIsSubmitLogin(false);
      }
    }
  }, [userInfo, isSubmitLogin]);

  // 点击提交
  const handleAddComment = useCallback(() => {
    // 设置显示
    setIsNoValue(false);
    if (!value) {
      setIsNoValue(true);
      Toast.error({ content: '请输入评论内容！' });
      return;
    }

    // 验证字数
    if (byteLength(value) > maxLength) {
      Toast.error({ content: '输入内容超过最大字数！' });
      return;
    }

    // 获取用户是否登录
    const login_status = window.CallNativeMethod('get_login_status');
    if (login_status !== '1') {
      // 未登录，弹出登录框
      window.CallNativeMethod('login');
      setIsSubmitLogin(true);
      return;
    }

    if (forumAddComment && forumAddComment.loading) {
      Toast.error({ content: '请勿重复提交！' });
      return;
    }
    const time = +new Date();
    setSubmitTime(time);

    dispatch(
      logging({
        category: 'C',
        action: 'Detail_Comment_Submit',
        label: '',
        param2: {
          source: logInfo.source,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          passInfos: [],
          id: relaseId,
        },
      }),
    );

    dispatch(
      postForumAddComment({
        bizIdentity: commentId,
        content: encodeURIComponent(xss(value)),
        grade: 5,
        passInfos: [],
        type,
        bizId: relaseId,
        submitTime: time,
      }),
    );
  }, [forumAddComment, relaseId, commentId, value]);

  const handleChange = useCallback(ev => {
    ev.persist();
    const inputValue = ev.target.value;
    setValue(inputValue);
  });

  const handleFocus = useCallback(ev => {
    ev.persist();
    setIsNoValue(false);
  });

  if (!relaseId) {
    return null;
  }

  return (
    <>
      <div className={styles.comment}>
        <div className={styles.comment_header}>
          <div className={styles.comment_header_icon}></div>
          <div className={styles.comment_header_text}>写点评论吧</div>
        </div>
        <div className={styles.comment_textarea_box}>
          <textarea
            className={isNoValue === true ? styles.comment_textarea_red : styles.comment_textarea}
            value={value}
            placeholder={'这里是评论内容'}
            onChange={handleChange}
            onFocus={handleFocus}
          />
          <div className={styles.comment_textarea_num}>
            <span className={byteLength(value) > maxLength ? styles.textarea_num_max : ''}>
              {byteLength(value)}
            </span>
            <span> / {maxLength}</span>
          </div>
        </div>
        <div className={styles.comment_bottom}>
          {/* <CheckSoft
            setCheckSoftList={setCheckSoftList}
            checkSoftList={checkSoftList}
            updateCheckSoft={updateCheckSoft}
            pageKey={'comment'}
          /> */}
          {value === '' ? (
            // eslint-disable-next-line no-underscore-dangle
            <div className={styles.comment_btn_}>发表</div>
          ) : (
            <div className={styles.comment_btn} onClick={handleAddComment}>
              发表
            </div>
          )}
        </div>
      </div>
      <CommentReview type={type} relaseId={relaseId} logInfo={logInfo} />
    </>
  );
};
